import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslationService} from '@core/service/translation.service';
import {PlaceDTO} from '@domain/place/place.dto';

@Pipe({
  name: 'place',
  pure: true
})
export class PlacePipe implements PipeTransform {

  private readonly translationService = inject(TranslationService);

  public transform(place: PlaceDTO | null): string | null {
    return this.getTownLabel(place);
  }

  private getTownLabel(place: PlaceDTO | null): string | null {
    if (!place) {
      return null;
    }
    let label = '';
    if (place.code) {
      label += `${place.code} `;
    }
    const preferredTr = this.translationService.getPreferred(place.translations || []);
    if (preferredTr) {
      label += ` ${preferredTr.name}`;
    }
    return label;
  }

}
